import { render } from "./Cuti.vue?vue&type=template&id=34596632"
import script from "./Cuti.vue?vue&type=script&lang=js"
export * from "./Cuti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__